import { render, staticRenderFns } from "./CollectionKeyhole.vue?vue&type=template&id=115fe9dd&scoped=true&"
import script from "./CollectionKeyhole.vue?vue&type=script&lang=js&"
export * from "./CollectionKeyhole.vue?vue&type=script&lang=js&"
import style0 from "./CollectionKeyhole.vue?vue&type=style&index=0&id=115fe9dd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115fe9dd",
  null
  
)

export default component.exports